module.exports = __webpack_public_path__ + "img/jpg-hongbao@2x.94d865cf.png";